module.exports = __webpack_public_path__ + "static/approve_app-7c82a61561d22f83a80538dc6f83ae75.png";